import { render, staticRenderFns } from "./CollectionReportInfoCard_EIBIC.vue?vue&type=template&id=108964e2&scoped=true&"
import script from "./CollectionReportInfoCard_EIBIC.vue?vue&type=script&lang=js&"
export * from "./CollectionReportInfoCard_EIBIC.vue?vue&type=script&lang=js&"
import style0 from "./CollectionReportInfoCard_EIBIC.vue?vue&type=style&index=0&id=108964e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108964e2",
  null
  
)

export default component.exports